import Image from 'components/Image';
import useGetImagePublic from 'lib/useGetImagePublic';
import { DataDetailCheckout } from '../types';

interface BusinessNameProps {
  data?: DataDetailCheckout;
}

const BusinessName: React.FC<BusinessNameProps> = ({ data }) => {
  if (!data || !data.business) {
    return (
      <div className="flex justify-center items-center text-sm text-gray-500 h-20">
        Data tidak tersedia
      </div>
    );
  }

  const { business, merchant } = data;
  const { data: logoUrl } = useGetImagePublic(business?.logo_path);

  if (!business) {
    return (
      <div className="flex justify-center items-center">
        <h3 className="text-xl font-semibold text-red-500">
          Business data not available
        </h3>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-row justify-center items-center">
        {logoUrl ? (
          <Image
            className="object-contain w-[120px] h-[120px]"
            src={logoUrl}
            alt="Business Logo"
          />
        ) : (
          <div className="flex flex-col items-center gap-1">
            <h3 className="text-2xl font-bold">
              {merchant?.name ? merchant?.name : '-'}
            </h3>
            <span className="text-xs font-medium">
              {business?.name ? business?.name : '-'}
            </span>
          </div>
        )}
      </div>
      {business?.header_title && (
        <div className="flex justify-center items-center">
          <span className="text-center">
            {business?.header_title ? business?.header_title : ''}
          </span>
        </div>
      )}
    </div>
  );
};

export default BusinessName;
